import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import PaymentOption from "./PaymentOption";
import { updatePaymentOption } from "../../Store/Checkout/Actions";

class PaymentOptionsContainer extends Component {
    constructor(props) {
        super(props);

        this.renderItems = this.renderItems.bind(this);
    }

    componentWillUnmount() {
        _.each(document.getElementsByClassName("payment-option"), el => el.classList.remove("feature--featured"));
        this.props.updatePaymentOption(-1);
    }

    renderItems() {
        const { options, paymentOption, updatePaymentOption } = this.props;
        return _.map(options, (option, i) =>
            <div className="col-md-6" key={i}>
                <PaymentOption
                    name={option.name}
                    items={option.items}
                    note={option.note}
                    disabled={option.disabled}
                    index={i}
                    active={i === paymentOption}
                    onSelect={updatePaymentOption}
                    onOptionClick={option.onClick}
                    cartItems={option.cartItems}
                />
            </div>
        );
    }

    render() {
        return <div className="row">
            {this.renderItems()}
        </div>;
    }
}

function mapStateToProps(state) {
    return {
        paymentOption: state.paymentOption
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updatePaymentOption: updatePaymentOption
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentOptionsContainer);